import { FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, TextField, Button, Divider } from '@mui/material';
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Link, useLocation } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import { ToastContainer, toast } from 'react-toastify';
import PrintAdmissionForm from './PrintAdmissionForm';

export default function ViewAdmissions() {
  const PrintAdmissionFormRef = useRef();
  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState(getCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDate());
  const [interviewDate, setInterviewDate] = useState('');
  const [interviewTime, setInterviewTime] = useState('');
  const [status, setStatus] = useState('');
  const [published, setPublished] = useState(false);
  const [publishingDateTime, setPublishingDateTime] = useState('');
  const [index, setIndex] = useState(null);
  const [FamilyPhoto, setFamilyPhoto] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [schedule, setSchedule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [DeleteId, setDeleteId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
  const location = useLocation();

  const handleFromDateChange = (e) => {
    setFromDate(e.target.value)
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value)
  };

  const fetchDetails = useCallback(async () => {
    try {
      const response = await fetch(`/api/getAdmission`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fromDate, toDate, status }),
      });

      if (response.ok) {
        const Data = await response.json();
        setData(Data);
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, [fromDate, toDate, status]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails, fromDate, toDate, status]);

  const handlePublish = async (e) => {
    setLoading(true)
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (!publishingDateTime) {
      if (!publishingDateTime) {
        toast.error("Publishing Date And Time Is Required!!")
      }

      setLoading(false);
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`/api/PublishAdmission`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ publishingDateTime }),
      });

      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData.message)
        setPublished(false);
        setPublishingDateTime(''); 
      } else {
        const responseData = await response.json();
        toast.error(responseData.error)
      }
    } catch (error) {
      console.error('Error uploading data:', error);
    } finally {
      setLoading(false)
    }
    setIsSubmitting(false);
  };

  const handleSelect = (AMID) => {
    setSelectedStudents((prev) =>
      prev.includes(AMID)
        ? prev.filter((id) => id !== AMID)
        : [...prev, AMID]
    );
  };

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (!interviewDate || !interviewTime) {
      if (!interviewDate) {
        toast.error("Interview Date Is Required!!")
      }

      if (!interviewTime) {
        toast.error("Interview Time Is Required!!")
      }

      setLoading(false);
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`/api/ScheduleInterview`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ interviewDate, interviewTime, selectedStudents }),
      });

      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData.message)
        setSchedule(false);
        setInterviewDate('');
        setInterviewTime('');
        setSelectedStudents([]);
      } else {
        const responseData = await response.json();
        toast.error(responseData.error)
      }
    } catch (error) {
      console.error('Error uploading data:', error);
    } finally {
      setLoading(false)
    }
    setIsSubmitting(false);
  };

  const handleStatusChange = async (AMID, status) => {
    try {
      const response = await fetch(`/api/UpdateStudentStatus/${AMID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status }),
      })
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message);
        fetchDetails();
      } else {
        const data = await response.json();
        toast.error(data.error)
      }
    } catch (error) {
      console.error('Error');
    }
  };

  const handleConfirmation = async (AMID) => {
    setIsDeleted(true);
    setDeleteId(AMID)
  };

  const handleCancel = async () => {
    setIsDeleted(false);
    setDeleteId('')
  };

  const handleDelete = async (AMID) => {
    try {
      const response = await fetch(`/api/DeleteAdmission/${AMID}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setData((prevData) => prevData.filter(item => item.AMID !== AMID));
        const data = await response.json();
        toast.success(data.message);
        setIsDeleted(false);
        setDeleteId('')
      } else {
        const data = await response.json();
        toast.error(data.error);
        setIsDeleted(false);
        setDeleteId('')
      }
    } catch (error) {
      console.error('Error deleting Subjects:', error);
    }
  };

  useEffect(() => {
    const currentRoute = location.pathname;
    const newBreadcrumbs = generateBreadcrumbs(currentRoute);
    setBreadcrumbs(newBreadcrumbs);
  }, [location]);

  const generateBreadcrumbs = (currentRoute) => {
    const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];

    const routeParts = currentRoute.split('/').filter(Boolean);
    let urlSoFar = '';
    routeParts.forEach((part) => {
      urlSoFar += `/${part}`;
      breadcrumbsArray.push({ label: part, url: urlSoFar });
    });

    return breadcrumbsArray;
  };

  return (
    <>
      <div className='mt-24 mx-2'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbs.map((breadcrumb, index) => (
              <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                {index === breadcrumbs.length - 1 ? (
                  breadcrumb.label
                ) : (
                  <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-4 col-md-3 mb-2'>
              <TextField label="From Date" variant="standard" fullWidth type='date' value={fromDate} onChange={handleFromDateChange} InputLabelProps={{ shrink: true }} />
            </div>
            <div className='col-4 col-md-3 mb-2'>
              <TextField label="To Date" variant="standard" fullWidth type='date' value={toDate} onChange={handleToDateChange} InputLabelProps={{ shrink: true }} />
            </div>
            <div className='col-4 col-md-3 mb-2'>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={status} onChange={(e) => setStatus(e.target.value)}>
                  <MenuItem value="0">Applied</MenuItem>
                  <MenuItem value="1">Scheduled</MenuItem>
                  <MenuItem value="2">Unselected</MenuItem>
                  <MenuItem value="3">Selected</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className='col-md-3 mb-2'>
              <Button variant='contained' color='primary' fullWidth onClick={() => setPublished(true)}>Publish Admission Form</Button>
            </div>
          </div>
        </div>
        <div id="recordCount" style={{ justifyContent: 'start' }}><span>Total No of Record(s): <strong className='text-danger'>{data.filter(item => item.AMID).filter((item, index, self) => index === self.findIndex(t => t.AMID === item.AMID)).length}</strong></span></div>
        <div className='shadow mb-5 rounded scrollOnXaxis' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <table className='table table-nowrap mb-0 mt-0'>
            <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem' }}>
              <tr style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <th>Select</th>
                <th>Date</th>
                <th>RefNo</th>
                <th>Name</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Religion</th>
                <th>FatherName</th>
                <th>MotherName</th>
                <th>Mobile</th>
                <th>Whatsapp</th>
                <th>Print</th>
                <th>Family</th>
                <th>Doc</th>
                <th>Interview Date/TIme</th>
                <th>Status</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.filter(item => item.AMID).filter((item, index, self) => index === self.findIndex(t => t.AMID === item.AMID)).map((item, i) => (
                <tr key={i} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', opacity: item.isValid === 1 ? 0.5 : 1, pointerEvents: item.isValid === 1 ? 'none' : 'auto', backgroundColor: item.isValid === 1 ? '#f5f5f5' : 'transparent' }}>
                  <td><input type="checkbox" checked={selectedStudents.includes(item.AMID)} onChange={() => handleSelect(item.AMID)} className="w-4 h-4" disabled={item.isValid === 1} /></td>
                  <td>{item.ApplyDate.slice(0, 10)}</td>
                  <td>{item.RefNo}</td>
                  <td>{item.Name}</td>
                  <td>{item.DOB.slice(0, 10)}</td>
                  <td>{item.Gender}</td>
                  <td>{item.Religion}</td>
                  <td>{item.FatherName}</td>
                  <td>{item.MotherName}</td>
                  <td>{item.Mobile}</td>
                  <td>{item.Whatsapp}</td>
                  <td>
                    {item.AMID === index ? (
                      <ReactToPrint
                        trigger={() => <span className='inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/10'><i className='bi bi-printer-fill fs-6'></i></span>}
                        content={() => PrintAdmissionFormRef.current}
                        onAfterPrint={() => setIndex(null)}
                      />
                    ) : (
                      <span className='inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10' onClick={() => setIndex(item.AMID)}><i className='bi bi-printer fs-6'></i></span>
                    )}
                  </td>
                  <td><span className='inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/10' onClick={() => setFamilyPhoto(item.FamilyPhoto)}><i class="bi bi-arrows-fullscreen fs-6 "></i></span></td>
                  <td>
                    <div className="flex gap-2 justify-center">
                      {item.FAadhar && (
                        <a href={`/Documents/${item.FAadhar}`} target="_blank" rel="noopener noreferrer" className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs flex items-center gap-1 border border-red-600" title="Father Aadhar"
                        ><i className="bi bi-file-pdf-fill"></i>F</a>
                      )}

                      {item.MAadhar && (
                        <a href={`/Documents/${item.MAadhar}`} target="_blank" rel="noopener noreferrer" className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs flex items-center gap-1 border border-red-600" title="Mother Aadhar">
                          <i className="bi bi-file-pdf-fill"></i> M
                        </a>
                      )}

                      {item.BithCerificate && (
                        <a href={`/Documents/${item.BithCerificate}`} target="_blank" rel="noopener noreferrer" className="bg-red-100 text-red-700 px-2 py-1 rounded text-xs flex items-center gap-1 border border-red-600" title="Birth Certificate">
                          <i className="bi bi-file-pdf-fill"></i> BC
                        </a>
                      )}

                    </div>
                  </td>
                  <td>{item.InterviewDate + '-' + item.InterviewTime}</td>
                  <td>
                    {[0, 1].includes(item.Status) ? (
                      <div className="flex gap-2">
                        <Button size="small" variant="contained" color="success" onClick={() => handleStatusChange(item.AMID, 3)} disabled={item.isValid === 1}>
                          Select
                        </Button>

                        <Button size="small" variant="contained" color="error" onClick={() => handleStatusChange(item.AMID, 2)} disabled={item.isValid === 1}>
                          Reject
                        </Button>
                      </div>
                    ) : (
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${item.Status === 0 ? "bg-gray-100 text-gray-600" :
                        item.Status === 1 ? "bg-blue-100 text-blue-700" :
                          item.Status === 2 ? "bg-red-100 text-red-700" :
                            "bg-green-100 text-green-700"}`}> {item.Status === 0 && "Applied"}
                        {item.Status === 1 && "Scheduled"}
                        {item.Status === 2 && "Rejected"}
                        {item.Status === 3 && "Selected"}
                      </span>
                    )}
                  </td>
                  <td><span className='bg-red-100 text-red-700' onClick={() => {if(item.isValid === 0) handleConfirmation(item.AMID)}}><i className='bi bi-trash-fill fs-6'></i></span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {selectedStudents.length > 0 &&
          <div className='flex justify-center gap-3 w-100' style={{ position: 'fixed', bottom: '10px', left: '50%', transform: 'translateX(-50%)', opacity: 1, cursor: 'pointer', zIndex: 1111 }}>
            <Button variant="contained" color="success" onClick={() => setSchedule(true)}>Schedule Interview</Button>
          </div>
        }
        <Dialog open={FamilyPhoto} onClose={() => setFamilyPhoto(null)} fullWidth>
          <DialogTitle>Student Family Picture</DialogTitle>
          <div className="h-40 flex items-center justify-center mt-2">
            <img src={`/Family/${FamilyPhoto}`} alt="Family" className="h-full object-contain" />
          </div>
        </Dialog>
        <Dialog open={schedule} onClose={() => setSchedule(false)} fullWidth>
          <DialogTitle>Schedule Student Interview</DialogTitle>
          <Divider />
          <DialogContent sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Set the interview date and time for the selected students.
            </Typography>
            <Box display="flex" flexDirection="column" gap={3}>
              <TextField label="Interview Date" type="date" fullWidth variant="outlined" value={interviewDate} onChange={(e) => setInterviewDate(e.target.value)} InputLabelProps={{ shrink: true }} />
              <TextField label="Interview Time" type="time" fullWidth variant="outlined" value={interviewTime} onChange={(e) => setInterviewTime(e.target.value)} InputLabelProps={{ shrink: true }} />
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setSchedule(false)} color="inherit">Cancel</Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>Save Schedule</Button>
          </DialogActions>
          {loading && (
            <div className="modal-backdrop show"></div>
          )}
          <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
            <div id="preloader">
              <div className="bar-container">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
              <h1>Loading...</h1>
            </div>
          </div>
        </Dialog> 
        <Dialog open={published} onClose={() => setPublished(false)} fullWidth>
          <DialogTitle>Publishe Admission Form</DialogTitle>
          <Divider />
          <DialogContent sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Set the date and time during which the admission form will be available for applicants to apply on the website.
            </Typography>
            <Box display="flex" flexDirection="column" gap={3}>
              <TextField label="Date & Time" type="datetime-local" fullWidth variant="outlined" value={publishingDateTime} onChange={(e) => setPublishingDateTime(e.target.value)} InputLabelProps={{ shrink: true }} /> 
            </Box>
          </DialogContent>
          <Divider />
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => setPublished(false)} color="inherit">Cancel</Button>
            <Button variant="contained" color="primary" onClick={handlePublish}>Save</Button>
          </DialogActions>
          {loading && (
            <div className="modal-backdrop show"></div>
          )}
          <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
            <div id="preloader">
              <div className="bar-container">
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
                <div className="bar"></div>
              </div>
              <h1>Loading...</h1>
            </div>
          </div>
        </Dialog>
      </div>
      {isDeleted && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
            <div className="modal-header">
              <h5 className="modal-title">Delete <strong>Admission?</strong></h5>
            </div>
            <div className="modal-body">
              <p>This Will Delete Admission <span className='text-danger'>Permannently</span></p>
              <div className='d-flex flex-row-reverse '>
                <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
                <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: 'none' }}>
        {data.length > 0 && index !== null && (<PrintAdmissionForm ref={PrintAdmissionFormRef} data={data.filter(i => i.AMID === index)} />)}
      </div>
      <ToastContainer />
    </>
  )
}

